import React from 'react';
import { X, Share2, Download, ChevronLeft } from 'lucide-react';

const GalleryDetail = ({ image, onBack, styles }) => {

const imageUrl = image?.image;


console.log("image",image)

  const formattedDate = image?.created_at
    ? new Date(image.created_at).toLocaleDateString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

  // ✅ SHARE FUNCTION
  const handleShare = async () => {
    if (!imageUrl) return;

    try {
      if (navigator.share) {
        await navigator.share({
          title: 'Lions Gallery Image',
          text: 'Check out this image',
          url: imageUrl
        });
      } else {
        // Fallback to WhatsApp
        const encoded = encodeURIComponent(imageUrl);
        window.open(
          `https://api.whatsapp.com/send?text=${encoded}`,
          "_blank"
        );
      }
    } catch (err) {
      console.log("Share cancelled or failed:", err);
    }
  };

  // ✅ DOWNLOAD FUNCTION
  const handleDownload = async () => {
    if (!imageUrl) return;

    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = `lions-gallery-${Date.now()}.jpg`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
      console.log("Download failed:", error);
    }
  };


  return (
    <div style={{ ...styles.container, backgroundColor: '#000', position: 'absolute', top: 0, zIndex: 100 }}>
      {/* Black Header with Close */}
      <div style={{ padding: '15px', display: 'flex', justifyContent: 'space-between', color: 'white' }}>
        <ChevronLeft onClick={onBack} style={{ cursor: 'pointer' }} />
        <X onClick={onBack} style={{ cursor: 'pointer' }} />
      </div>

      {/* Main Image Container */}
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <img 
          src={image?.image} 
          alt="Preview" 
          style={{ width: '100%', maxHeight: '70%', objectFit: 'contain' }} 
        />
      </div>
      <div style={{ padding: "15px", color: "white" }}>
        {image?.title && (
          <h2 style={{ margin: "5px 0", fontSize: "18px", fontWeight: "bold" }}>
            {image.title}
          </h2>
        )}
        {(image?.club || formattedDate) && (
          <p style={{ margin: "2px 0", fontSize: "12px", opacity: 0.8 }}>
            {image?.club ? image.club : ""} {image?.club && formattedDate ? "•" : ""}{" "}
            {formattedDate}
          </p>
        )}
        {image?.description && (
          <p style={{ marginTop: "10px", fontSize: "14px", lineHeight: "1.4" }}>
            {image.description}
          </p>
        )}
      </div>

      {/* Simplified Footer Actions */}
      <div style={{ padding: '20px', display: 'flex', gap: '10px', backgroundColor: '#000' }}>
        <button style={{
          flex: 1, backgroundColor: '#333', color: 'white', border: 'none', padding: '15px',
          borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', fontWeight: 'bold'
        }}    onClick={handleShare}>
          <Share2 size={20} /> Share
        </button>
        
        <button          onClick={handleDownload} style={{
          flex: 1, backgroundColor: '#FFC20E', color: '#000', border: 'none', padding: '15px',
          borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', fontWeight: 'bold'
        }}>
          <Download size={20} /> Download
        </button>
      </div>
    </div>
  );
};


export default GalleryDetail;